import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Star, ArrowRight, ArrowUpRight, MessageSquare, ExternalLink, ThumbsUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ReviewsPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Google Business Profile URL
  const GOOGLE_BUSINESS_URL = 'https://www.google.com/maps/place/RC+Awards/@32.7548,-117.13735,17z/data=!4m8!3m7!1s0x80d954d3a5d9b36d:0x2ae1885968717e70!8m2!3d32.7548!4d-117.13735!9m1!1b1!16s%2Fg%2F1tffdh0j';
  const GOOGLE_REVIEW_URL = 'https://g.page/r/CXB-cWhaGOGqEAI/review';

  const reviews = [
    {
      name: 'Krisiana K.',
      avatar: 'https://i.pravatar.cc/150?img=32',
      rating: 5,
      comment: 'Amazing team and very helpful! Got the job done quickly and efficiently! I had a photo frame engraved and it came out beautiful! Will definitely be back here!!!',
      date: 'June 3, 2026',
      source: 'Google',
      response: "Thank you so much for the 5-star review, Krisiana! We truly appreciate your support and are glad we had the opportunity to work with you. It means a lot to our team, and we look forward to helping you again in the future!"
    },
    {
      name: 'Mathy S.',
      avatar: 'https://i.pravatar.cc/150?img=25',
      rating: 5,
      comment: 'Abe and Jonathan were GREAT!! They did a miracle work!! I needed a last minute engraving and they were able to make it with a smile on their faces and amazing attitude!!! They were extremely helpful!!!! I absolutely recommend them!!!',
      date: 'June 1, 2026',
      source: 'Google',
      response: "Thank you for taking the time to leave us a 5-star review, Mathy! We really appreciate your business and your kind support. It was a pleasure working with you, and we hope to see you again soon."
    },
    {
      name: 'Nico D.',
      avatar: 'https://i.pravatar.cc/150?img=53',
      rating: 5,
      comment: 'Better late than never! YONATHAN IS THE BEST!! I had two back-to-back orders and he came through with amazing work that is only matched by his professionalism and top-tier customer service! I will be back and I will refer RC Awards to everyone!!!!',
      date: 'May 29, 2026',
      source: 'Google',
      response: "We truly appreciate your support, Nico! Thank you for taking the time to leave us a 5-star review. It was a pleasure working with you, and we're glad you had a great experience with us. Looking forward to helping you again in the future!"
    },
    {
      name: 'Thomas B.',
      avatar: 'https://i.pravatar.cc/150?img=60',
      rating: 5,
      comment: 'Amazing guy! Good business man very friendly good positive attitude and very knowledgeable about the world',
      date: 'May 22, 2026',
      source: 'Google',
      response: "Your 5-star review really made our day, Thomas. Thank you for trusting us with your project and for supporting our business. We're grateful for the opportunity and hope to work with you again soon!"
    },
    {
      name: 'Kenny P.',
      avatar: 'https://i.pravatar.cc/150?img=12',
      rating: 5,
      comment: 'Amazing trophy shop, did multiple awards with them and each one came out perfectly!',
      date: 'May 12, 2026',
      source: 'Google',
      response: "We truly appreciate your support, Kenny! Thank you for taking the time to leave us a 5-star review. It was a pleasure working with you, and we're glad you had a great experience with us. Looking forward to helping you again in the future!"
    },
    {
      name: 'Jessica L.',
      avatar: 'https://i.pravatar.cc/150?img=44',
      rating: 5,
      comment: 'Absolutely amazing work. I needed a last minute plaque. It is May, so naturally every other store I called blew me off since they were busy (busy season for them with graduations and all). Not RC Awards. They were kind enough to take my last minute request. They were thorough. Communicative. And the plaque was PERFECT! HIGHLY recommend!!! I will be coming back when I need more awards for my employees!!',
      date: 'May 9, 2026',
      source: 'Google',
      response: "Thanks so much, Jessica! We really appreciate you taking the time to leave a review. It was a pleasure working with you, and we're glad you were happy with everything. Hope to work with you again down the road."
    },
    {
      name: 'Nesha P.',
      avatar: 'https://i.pravatar.cc/150?img=45',
      rating: 5,
      comment: 'I will be back! I love RC Awards thank you guys so much!!!',
      date: 'April 29, 2026',
      source: 'Google',
      response: "We truly appreciate your positive feedback, Nesha! It's always a pleasure to hear from satisfied customers like you. Thanks for taking the time to share your experience!"
    },
    {
      name: 'Ms Q.',
      avatar: 'https://i.pravatar.cc/150?img=47',
      rating: 5,
      comment: 'Yes! Last minute order I put in they saved me! The trophy is so nice! I love it thy have very good customer service and good prices!',
      date: 'April 29, 2026',
      source: 'Google'
    },
    {
      name: 'Jason N.',
      avatar: 'https://i.pravatar.cc/150?img=8',
      rating: 5,
      comment: 'Exceptional service and high quality trophies! I had a rushed order for a corporate event, and Yonathan & crew went above and beyond to ensure the order was precisely accurate and on time.',
      date: 'April 23, 2026',
      source: 'Google',
      response: "Thanks so much for the great review, Jason. We really appreciate you taking the time to share your experience. It means a lot to us, and we're glad everything came out the way you wanted. Looking forward to working with you again soon!"
    },
    {
      name: 'James R.',
      avatar: 'https://i.pravatar.cc/150?img=11',
      rating: 5,
      comment: 'We bought two awards from RC Awards. They have a wide variety of styles. They inscribed our text into the awards flawlessly and quickly. The price was reasonable and the service was friendly.',
      date: 'April 22, 2026',
      source: 'Google',
      response: "We truly appreciate the thoughtful review, James! It means a lot that you took the time to write that. We're really glad you were happy with the quality and the overall experience. We put a lot of care into every order, so hearing that it showed on your end goes a long way. Looking forward to working together again and helping with anything you need down the line!"
    }
  ];

  return (
    <div data-testid="reviews-page" className="min-h-screen pt-28 pb-20 bg-white">
      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-6 py-16 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs uppercase tracking-widest text-[#D4AF37] mb-3 font-semibold">Customer Testimonials</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl text-[#1a365d] mb-4 font-bold">
            What San Diego Says About RC Awards
          </h1>
          <p className="text-base text-gray-600 max-w-2xl mx-auto mb-8">
            Don't just take our word for it — see why hundreds of San Diego businesses, schools, and organizations trust RC Awards for their custom trophies, plaques, and recognition products.
          </p>

          {/* Rating Summary */}
          <div className="inline-flex flex-col sm:flex-row items-center gap-6 bg-gray-50 rounded-2xl p-6 border border-gray-100">
            <div className="text-center sm:text-left">
              <div className="flex items-center justify-center sm:justify-start gap-2 mb-1">
                <span className="text-5xl font-bold text-[#1a365d]">5.0</span>
                <div className="flex flex-col items-start">
                  <div className="flex">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={20} className="fill-[#D4AF37] text-[#D4AF37]" />
                    ))}
                  </div>
                  <span className="text-sm text-gray-500">Google Rating</span>
                </div>
              </div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <p className="text-3xl font-bold text-[#1a365d]">200+</p>
              <p className="text-sm text-gray-500">Verified Reviews</p>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <p className="text-3xl font-bold text-[#1a365d]">100%</p>
              <p className="text-sm text-gray-500">Recommended</p>
            </div>
          </div>
        </motion.div>
      </section>

      {/* Leave a Review CTA */}
      <section className="max-w-6xl mx-auto px-6 mb-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-[#1a365d] to-[#2d4a7c] rounded-2xl p-8 md:p-10"
        >
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h2 className="text-2xl font-bold text-white mb-2">Had a Great Experience?</h2>
              <p className="text-white/70">We'd love to hear from you! Share your experience on Google.</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={GOOGLE_REVIEW_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] text-[#1a365d] px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#c9a432] transition-colors inline-flex items-center justify-center gap-2"
              >
                <MessageSquare size={16} />
                Write a Review
              </a>
              <a
                href={GOOGLE_BUSINESS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 border border-white/30 text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-white/20 transition-colors inline-flex items-center justify-center gap-2"
              >
                View on Google
                <ExternalLink size={14} />
              </a>
            </div>
          </div>
        </motion.div>
      </section>

      {/* Reviews Grid */}
      <section className="max-w-6xl mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-lg hover:border-gray-200 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <img src={review.avatar} alt={review.name} className="w-12 h-12 rounded-full object-cover" />
                  <div>
                    <p className="font-semibold text-[#1a365d]">{review.name}</p>
                    <div className="flex items-center gap-2">
                      <div className="flex">
                        {[...Array(review.rating)].map((_, i) => (
                          <Star key={i} size={12} className="fill-[#D4AF37] text-[#D4AF37]" />
                        ))}
                      </div>
                      <span className="text-xs text-gray-400">{review.date}</span>
                    </div>
                  </div>
                </div>
                <span className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded font-medium flex items-center gap-1">
                  <svg viewBox="0 0 24 24" className="w-3 h-3" fill="currentColor">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  Google
                </span>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{review.comment}</p>
              
              {review.response && (
                <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-[#D4AF37]">
                  <p className="text-xs font-semibold text-[#1a365d] mb-1 flex items-center gap-1">
                    <ThumbsUp size={12} />
                    Response from RC Awards
                  </p>
                  <p className="text-xs text-gray-600 leading-relaxed">{review.response}</p>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        {/* Load More / View All on Google */}
        <div className="text-center mt-12">
          <a
            href={GOOGLE_BUSINESS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#1a365d] font-medium hover:text-[#D4AF37] transition-colors"
          >
            View All Reviews on Google
            <ArrowUpRight size={16} />
          </a>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl text-[#1a365d] mb-4 font-bold">Ready to Join Our Happy Customers?</h2>
            <p className="text-gray-600 mb-8 max-w-lg mx-auto">
              Experience the RC Awards difference — quality products, fast turnaround, and exceptional service that keeps San Diego coming back.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/contact"
                className="bg-[#D4AF37] text-[#1a365d] px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-[#c9a432] transition-colors inline-flex items-center justify-center gap-2"
              >
                Get a Free Quote
                <ArrowRight size={14} />
              </Link>
              <a
                href="https://www.rcawards.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="border border-gray-200 text-gray-600 px-7 py-3.5 rounded-full text-sm font-medium hover:border-gray-300 hover:bg-white transition-colors inline-flex items-center justify-center gap-2"
              >
                Shop Online
                <ArrowUpRight size={14} />
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ReviewsPage;
